import React, { useState, useEffect, useRef } from "react";
import { Button, Input, Space } from 'antd';
import ImageDisplay from "../../components/ImageDisplay/ImageDisplay";
const { TextArea } = Input;

function QuestionAndAnswer (props){

    const {question, correctAnswer, reason, selectOption = '', url} = props;
    const [selOpt, setSelOpt] = useState(selectOption); // textarea string
    const startTime = useRef(null);
    const submitted = !!selectOption;

    useEffect(()=>{
        startTime.current = Date.now();
    }, [])

    const handleSubmit = ()=>{
        const timeSpend = Date.now() - startTime.current;
        props.valueChange({...props, selectOption: selOpt, time_spend: timeSpend});
        props.onSubmit({...props, selectOption: selOpt, time_spend: timeSpend})
    }

    return (
        <Space direction="vertical" className= 'h-100 mt-2 w-100'>
            <p style={{fontWeight: 'bold', fontSize: '14px'}}>
                {props.index + 1} : {question}
            </p>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <ImageDisplay imgList={url}/>
            </div>
            <div style={{width: '100%'}}>
                <TextArea value={selOpt} onChange={e=>setSelOpt(e.target.value)} style={{height: '35vh'}}/>
            </div>
            {submitted ?
            <>
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Answer: {correctAnswer}</p>
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Explaination: {reason}</p>
            </>
                :
                null
            }
            <Button onClick={handleSubmit} style={{width: '100%'}} type={'primary'}>Submit</Button>
        </Space>
    );
}

export default QuestionAndAnswer;